// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LaborDetails from './labor-details';
import OtherCreditDetails from './other-credit-details';
import PartDetails from './part-details';
import PipRequiredItem from '@deere/cps-it.warranty-model-factory/lib/pip-required-item';

const PipRequiredItemsList = props => (
    <ul className='pip-required-items-list'>
        {
            props.requiredItems.map((requiredItem, index) => {

                let item;

                if (requiredItem.type === 'MAT') {

                    item = (<PartDetails
                        item={requiredItem}
                        key={index}
                            />);

                } else if (requiredItem.type === 'SUBL') {

                    item = (<OtherCreditDetails
                        item={requiredItem}
                        key={index}
                            />);

                } else {

                    item = (<LaborDetails
                        item={requiredItem}
                        key={index}
                            />);

                }

                return item;

            })
        }
    </ul>
);

PipRequiredItemsList.displayName = 'PipRequiredItemsList';
PipRequiredItemsList.propTypes = {
    requiredItems: PropTypes.arrayOf(PropTypes.instanceOf(PipRequiredItem)).isRequired
};

export default PipRequiredItemsList;



// WEBPACK FOOTER //
// ./src/pip/pip-details/components/pip-required-items-list.js